import { render } from "./dimensionAlternate.vue?vue&type=template&id=6aa2813b&scoped=true"
import script from "./dimensionAlternate.vue?vue&type=script&lang=js"
export * from "./dimensionAlternate.vue?vue&type=script&lang=js"

import "./dimensionAlternate.vue?vue&type=style&index=0&id=6aa2813b&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa2813b"]])

export default __exports__